import standardAction from '../../../utilities/standard-action';
import ActionTypes from '../constants/action-types';

export default function closeClearTextKeyDialog() {
  return standardAction(ActionTypes.CLOSE_CLEAR_TEXT_KEY_DIALOG);
}
